export enum InstructionType {
    WARNING = "WARNING",
    INFO = "INFO",
}

export type Instruction = Readonly<{
    type: InstructionType
    title: string
    text: string
}>
